import { render, staticRenderFns } from "./GarbageAccessReportScreen.vue?vue&type=template&id=5c7e511e"
import script from "./GarbageAccessReportScreen.vue?vue&type=script&lang=js"
export * from "./GarbageAccessReportScreen.vue?vue&type=script&lang=js"
import style0 from "./GarbageAccessReportScreen.vue?vue&type=style&index=0&id=5c7e511e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports